import clientAPI from "@/api/ClientAPIMixin.js";
import i18n from '@/plugins/i18n.js';

const CustomerEditModel = {
    headerTitle: i18n.t('servicesystem.common_objects.customer.customer_details'),
    enabledIcon: "mdi-information",
    disabledIcon: "mdi-information-off",
    listItemTextKey: "Name",

    fields: [
        { type: "input", label: i18n.t('servicesystem.common_objects.customer.customer_name'), valuekey: "Name", editable: true, rules: "noempty", defaultValue: "" },
        [
            { type: "input", label: i18n.t('servicesystem.common_objects.customer.customer_number'), valuekey: "Id", editable: false, rules: "", defaultValue: -1, cols: 6 },
            { type: "input", label: i18n.t('servicesystem.common_objects.customer.organization_number'), valuekey: "OrganisationNumber", editable: true, rules: "", defaultValue: "" },
        ],
        [
            { type: "input", label: i18n.t('servicesystem.common_objects.customer.credit_limit'), valuekey: "CreditLimit", editable: true, rules: "", defaultValue: 0 },
            { type: "input", label: i18n.t('servicesystem.common_objects.customer.credit_block'), valuekey: "CreditLimitExceeded", editable: false, rules: "", defaultValue: "", cols: 6 },
        ],
        { type: "switch", label: i18n.t('servicesystem.common_objects.customer.free_from_vat'), valuekey: "FreeFromVat", editable: true, defaultValue: true },
        { type: "switch", label: i18n.t('servicesystem.common_objects.customer.active'), valuekey: "IsActive", editable: "onlyedit", defaultValue: true },
    ],

    methods: {
        async save(customer) {
            return clientAPI.methods.changeCustomerById(customer);
        },
        async create(newcustomer) {
            return clientAPI.methods.createCustomer(newcustomer);
        },
    }
}

export default CustomerEditModel;